import React from 'react';

export interface IMenuContainerProps {
  content?: React.ReactFragment;
  footer?: React.ReactFragment;
}

export const MenuContainer: React.FC<IMenuContainerProps> = (props) => {
  return (
    <>
      <div className="second-color main-menu-content">{props.content}</div>
      <div className="main-menu-footer">{props.footer}</div>
    </>
  );
};
